import { motion } from "framer-motion";
import { Zap, Package, Rocket, Handshake, Target, Infinity as InfinityIcon } from "lucide-react";
import { useLang } from "@/context/LangContext";

const icons = [Zap, Package, Rocket, Handshake, Target, InfinityIcon];

const Benefits = () => {
  const { t } = useLang();
  return (
    <section id="benefits" className="relative py-32 md:py-40 overflow-hidden">
      <div className="absolute inset-0 bg-dots opacity-[0.25] mask-fade-b pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <div className="text-[11px] tracking-[0.3em] uppercase text-po-accent mb-6">
            {t.benefits.eyebrow}
          </div>
          <h2 className="font-display text-white text-4xl sm:text-5xl md:text-6xl tracking-[-0.03em] font-semibold leading-[1.02]">
            {t.benefits.title}
            <br />
            <span className="font-serif-it text-po-text2">{t.benefits.titleItalic}</span>
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.benefits.cards.map((c, i) => {
            const Icon = icons[i] || Zap;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                data-testid={`benefit-card-${i}`}
                className="group relative rounded-3xl bg-po-surface/40 border border-white/[0.05] p-8 backdrop-blur-sm overflow-hidden h-full hover:border-po-accent/30 transition-all duration-500"
              >
                <div className="absolute -bottom-20 -right-10 h-44 w-44 rounded-full bg-po-accent/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative">
                  <div className="h-10 w-10 rounded-xl bg-po-accent/10 border border-po-accent/20 flex items-center justify-center text-po-accent mb-6">
                    <Icon className="h-4.5 w-4.5" />
                  </div>
                  <h3 className="font-display text-white text-xl md:text-[22px] tracking-tight font-medium leading-tight">{c.t}</h3>
                  <p className="mt-3 text-po-text2 text-[15px] leading-relaxed">{c.d}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
